import { render, staticRenderFns } from "./adminTraining.vue?vue&type=template&id=508f33b1"
import script from "./adminTraining.vue?vue&type=script&lang=js"
export * from "./adminTraining.vue?vue&type=script&lang=js"
import style0 from "./adminTraining.vue?vue&type=style&index=0&id=508f33b1&prod&lang=css"
import style1 from "./adminTraining.vue?vue&type=style&index=1&id=508f33b1&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports